import React from 'react';
import './tile.scss';

export interface TileProps {
  title: string;
  /** Optional subtitle rendered below the title in the header. */
  subtitle?: string;
  /** Right-side slot for controls (settings cog, date pill, etc). */
  actions?: React.ReactNode;
  /** Bottom band for hover readouts. Receives either a hint string or live content. */
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}

/**
 * Card shell used by every Automation Dashboard panel.
 * Provides a title bar, body, and optional footer hint/readout band.
 */
export const Tile: React.FC<TileProps> = ({
  title,
  subtitle,
  actions,
  footer,
  children,
  className,
  ariaLabel,
}) => (
  <section
    className={['tile', className].filter(Boolean).join(' ')}
    aria-label={ariaLabel ?? title}
  >
    <header className="tile__header">
      <div className="tile__title-group">
        <span className="tile__title">{title}</span>
        {subtitle && <span className="tile__subtitle">{subtitle}</span>}
      </div>
      {actions ? <div className="tile__actions">{actions}</div> : null}
    </header>
    <div className="tile__body">{children}</div>
    {footer !== undefined ? (
      <div className="tile__footer">{footer}</div>
    ) : null}
  </section>
);

Tile.displayName = 'Tile';
